/**
 * ConfirmSaleConfirmationModal - Tipo 1: Modal de Confirmación
 *
 * Mismo diseño que CloseConfirmationModal ("Perderás los cambios…").
 */

import React from 'react';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { ConfirmationModal } from '../../ui/Modal';

export interface ConfirmSaleConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const ConfirmSaleConfirmationModal: React.FC<ConfirmSaleConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="¿Confirmar esta venta?"
      message="Se registrará la venta y se actualizará el inventario según las piezas marcadas como entregadas."
      confirmText="Confirmar"
      cancelText="Volver"
      variant="default"
      loading={loading}
      icon={<CheckCircleIcon />}
    />
  );
};

export default ConfirmSaleConfirmationModal;
